var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { computed, makeObservable } from 'mobx';
import { ensureString, toNumber } from '../../../utils/helper/lodash_replacements';
export class AppMeasure {
    parent;
    constructor(parent) {
        makeObservable(this);
        this.parent = parent;
    }
    get app() {
        return this.parent;
    }
    get appWidthInPixel() {
        if (this.app.appCookies.reactiveCookies.get('width')) {
            return toNumber(this.app.appCookies.reactiveCookies.get('width'));
        }
        return 1400;
    }
    set appWidthInPixel(width) {
        this.app.appCookies.reactiveCookies.set('width', ensureString(width));
    }
    get appHeightInPixel() {
        return toNumber(this.app.appCookies.reactiveCookies.get('height')) || 1000;
    }
    set appHeightInPixel(height) {
        this.app.appCookies.reactiveCookies.set('height', ensureString(height));
    }
}
__decorate([
    computed
], AppMeasure.prototype, "appWidthInPixel", null);
__decorate([
    computed
], AppMeasure.prototype, "appHeightInPixel", null);
